import React from 'react'
import Reflux from 'reflux'
import { Col, Row } from 'reactstrap'
import PointsEarnedChart from 'Components/dashboard/PointsEarnedChart.js'
import { LoginStore } from 'Stores/loginStore'
import _ from 'lodash'
import PointsEarnedTotalChart from 'Components/dashboard/PointsEarnedTotalChart.js'
import LastMonthTotalPoints from 'Components/dashboard/LastMonthTotalPoints.js'
import LastMonthTotalActivationPoints from 'Components/dashboard/LastMonthTotalActivationPoints.js'
import PointsUsedChart from 'Components/dashboard/PointsUsedChart.js'
import PointsUsedYearlyTotals from 'Components/dashboard/PointsUsedYearlyTotals.js'
import PointsRemainingChart from 'Components/dashboard/PointsRemainingChart.js'
import ActivationPointsRemainingChart from 'Components/dashboard/ActivationPointsRemainingChart.js'
import PointsRemainingYearlyTotals from 'Components/dashboard/PointsRemainingYearlyTotals.js'
import KamUsersChart from 'Components/dashboard/KamUsersChart.js'
import UnusedActiveInActivePointsChartLine from 'Components/dashboard/UnusedActiveInActivePointsChartLine.js'
import OrdersMonthlyChart from 'Components/dashboard/OrdersMonthlyChart.js'
import OrdersYearlyChart from 'Components/dashboard/OrdersYearlyChart.js'
import DealersActiveInactiveChart from '../components/dashboard/DealersActiveInactiveChart'
import UsersChartLineAll from '../components/dashboard/UsersChartLineAll'
import UsersChartLineApproved from '../components/dashboard/UsersChartLineAllApproved'
import UsersChartLineDeclined from '../components/dashboard/UsersChartLineAllDeclined'

export default class ClientDashboard extends Reflux.Component {
  constructor(props) {
    super(props)
    this.stores = [LoginStore]
    this.storeKeys = ['settings']
  }

  render() {
    return (
      <Row className='py-4'>
        {_.get(this.state, 'settings.features.enableWalletActivation') && (
          <Col xs='12'>
            <LastMonthTotalActivationPoints />
          </Col>
        )}
        <Col xs='12'>
          <LastMonthTotalPoints isWalletActivation={_.get(this.state, 'settings.features.enableWalletActivation')} />
        </Col>
        <Col lg='6'>
          <PointsEarnedChart />
        </Col>
        <Col lg='6'>
          <PointsEarnedTotalChart />
        </Col>
        <Col lg='6'>
          <PointsUsedChart />
        </Col>
        <Col lg='6'>
          <PointsUsedYearlyTotals />
        </Col>
        <Col lg='6'>
          <PointsRemainingChart isWalletActivation={_.get(this.state, 'settings.features.enableWalletActivation')} />
        </Col>
        <Col lg='6'>
          <PointsRemainingYearlyTotals isWalletActivation={_.get(this.state, 'settings.features.enableWalletActivation')} />
        </Col>
        {_.get(this.state, 'settings.features.enableWalletActivation') && (
          <Col lg='12'>
            <ActivationPointsRemainingChart />
          </Col>
        )}
        <Col lg='6'>
          <OrdersMonthlyChart />
        </Col>
        <Col lg='6'>
          <OrdersYearlyChart />
        </Col>
        <Col lg='6'>
          <UsersChartLineApproved />
        </Col>
        <Col lg='6'>
          <UsersChartLineDeclined />
        </Col>
        <Col xs='12'>
          <KamUsersChart />
        </Col>
        <Col xs='12'>
          <DealersActiveInactiveChart />
        </Col>
        <Col lg='6'>
          <UsersChartLineAll />
        </Col>
        <Col lg='6'>
          <UnusedActiveInActivePointsChartLine />
        </Col>
      </Row>
    )
  }
}
